export const MATCH_VARIANT = {
    STANDARD: "standard",
};
export const GAME_OVERRIDE = Object.freeze({
    PVAI: 64,
    PVP: 65,
    SCENARIO: 66,
    TOURNAMENT: 68,
});
export const CHESS_EMPTY_BOARD_FEN = "8/8/8/8/8/8/8/8 w - - 0 1";
export const CHESS_START_POSITION = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
export const FEN_PIECES = ["K", "Q", "R", "B", "N", "P", "k", "q", "r", "b", "n", "p"];
export const CHESS_SIDE = Object.freeze({
    BLACK: "black",
    WHITE: "white",
});
export const CHESS_PIECES = Object.freeze({
    K: "KING",
    Q: "QUEEN",
    R: "ROOK",
    B: "BISHOP",
    N: "KNIGHT",
    P: "PAWN",
});
// a function that take CHESS_PIECES and CHESS_SIDE and return their fen equivalent
export const getFenPiece = (piece, side) => {
    if (!piece || !side)
        return "";
    const fenPiece = piece.toUpperCase() === CHESS_PIECES.N ? "N" : piece[0];
    if (!FEN_PIECES.includes(fenPiece))
        return "";
    if (side === CHESS_SIDE.WHITE) {
        return fenPiece.toUpperCase();
    }
    if (side === CHESS_SIDE.BLACK) {
        return fenPiece.toLowerCase();
    }
    return "";
};
export const GAME_RESULT = Object.freeze({
    CHECKMATE: "checkmate",
    STALEMATE: "stalemate",
    THREEFOLD_REPETITION: "threefold_repetition",
    INSUFFICIENT_MATERIAL: "insufficient_material",
    DRAW: "draw",
    DRAW_BY_AGREEMENT: "draw by agreement",
    GAME_OVER: "game_over",
    ABORT: "abort", // abort when leewayDuration runs out in non tournament game
    WHITE_ABORT: "white_abort", // abort by white when leewayDuration remains
    BLACK_ABORT: "black_abort", // abort by black when leewayDuration remains
    WHITE_TIMEOUT_VS_INSUFFICIENT: "white_timeout_vs_insufficient",
    BLACK_TIMEOUT_VS_INSUFFICIENT: "black_timeout_vs_insufficient",
    BARE_KING: "bare king", // legacy — kept for reading old records; do not write new ones
    TIMEOUT: "timeout",
    FORFEIT: "forfeit",
    RESIGN: "resign",
    END: "end",
    DISQUALIFIED: "disqualified",
    INVALID: "invalid",
});
// Options for the admin "override result" dropdown. Order is intentional (UI grouping).
// `disabled: true` keeps the value visible for legacy data but prevents new selections.
export const GAME_RESULT_ADMIN_OPTIONS = Object.freeze([
    { value: GAME_RESULT.ABORT, label: "abort" },
    { value: GAME_RESULT.WHITE_ABORT, label: "white_abort" },
    { value: GAME_RESULT.BLACK_ABORT, label: "black_abort" },
    { value: GAME_RESULT.FORFEIT, label: "forfeit" },
    { value: GAME_RESULT.CHECKMATE, label: "checkmate" },
    { value: GAME_RESULT.STALEMATE, label: "stalemate" },
    { value: GAME_RESULT.THREEFOLD_REPETITION, label: "threefold_repetition" },
    { value: GAME_RESULT.INSUFFICIENT_MATERIAL, label: "insufficient_material" },
    { value: GAME_RESULT.DRAW, label: "draw" },
    { value: GAME_RESULT.GAME_OVER, label: "game over", disabled: true },
    { value: GAME_RESULT.TIMEOUT, label: "timeout" },
    {
        value: GAME_RESULT.WHITE_TIMEOUT_VS_INSUFFICIENT,
        label: "white timeout vs insufficient material",
    },
    {
        value: GAME_RESULT.BLACK_TIMEOUT_VS_INSUFFICIENT,
        label: "black timeout vs insufficient material",
    },
    { value: GAME_RESULT.BARE_KING, label: "bare king (legacy)", disabled: true },
    { value: GAME_RESULT.RESIGN, label: "resign" },
    { value: GAME_RESULT.DRAW_BY_AGREEMENT, label: "draw by agreement" },
    { value: GAME_RESULT.DISQUALIFIED, label: "disqualified" },
    { value: GAME_RESULT.INVALID, label: "invalid" },
]);
// Options for filter dropdowns (no abort/game over/invalid; bare king stays
// selectable for filtering legacy records).
export const GAME_RESULT_FILTER_OPTIONS = Object.freeze([
    { value: GAME_RESULT.FORFEIT, label: "forfeit" },
    { value: GAME_RESULT.CHECKMATE, label: "checkmate" },
    { value: GAME_RESULT.STALEMATE, label: "stalemate" },
    { value: GAME_RESULT.THREEFOLD_REPETITION, label: "threefold repetition" },
    { value: GAME_RESULT.INSUFFICIENT_MATERIAL, label: "insufficient material" },
    { value: GAME_RESULT.DRAW, label: "draw" },
    { value: GAME_RESULT.TIMEOUT, label: "timeout" },
    {
        value: GAME_RESULT.WHITE_TIMEOUT_VS_INSUFFICIENT,
        label: "white timeout vs insufficient material",
    },
    {
        value: GAME_RESULT.BLACK_TIMEOUT_VS_INSUFFICIENT,
        label: "black timeout vs insufficient material",
    },
    { value: GAME_RESULT.BARE_KING, label: "bare king (legacy)" },
    { value: GAME_RESULT.RESIGN, label: "resign" },
    { value: GAME_RESULT.DRAW_BY_AGREEMENT, label: "draw by agreement" },
    { value: GAME_RESULT.DISQUALIFIED, label: "disqualified" },
]);
export const LEEWAY_DURATION = 30; // 30s for first move
export const TIMEOUT_LEEWAY_SECONDS = 2; // 2s to wait before handle timeout
export const MATCH_STATUS = Object.freeze({
    CREATED: "created",
    STARTED: "started",
    ABORTED: "aborted",
    LIVE: "live",
    FINISHED: "finished",
});
export const SIMUL_STATUS = Object.freeze({
    CREATED: "created",
    STARTED: "started",
    FINISHED: "finished",
    CLOSED: "closed",
});
export const TOURNAMENT_GAME_RESULT = Object.freeze({
    LOSS: 0,
    WIN: 1,
    DRAW: 2,
    FORFEITW: 3,
    FORFEITL: 4,
    FORFEITD: 5,
    UNFINISHED: 6,
    FULLBYE: 7,
    ZEROBYE: 8,
    HALFBYE: 9,
    PAIRINGBYE: 10,
    DISQUALIFIED: 11,
});
export const TOURNAMENT_FIDE_GAME_RESULT = Object.freeze({
    0: "0",
    1: "1",
    2: "=",
    3: "+",
    4: "-",
    5: "=",
    6: "",
    7: "F",
    8: "Z",
    9: "H",
    10: "U",
    11: "Z",
});
export const TOURNAMENT_GAME_RESULT_TEXT = Object.freeze([
    "LOSS",
    "WIN",
    "DRAW",
    "Forfeit Win",
    "Forfeit Loss",
    "Forfeit Draw",
    "Unfinished",
    "FULLBYE",
    "ZEROBYE",
    "HALFBYE",
    "PAIRINGBYE",
    "DISQUALIFIED",
]);
export const TOURNAMENT_GAME_RESULT_SCORE = Object.freeze([0, 1, 0.5, 1, 0, 0.5, null, 1, 0, 0.5, 1, 0]);
export const TOURNAMENT_DEFAULT_SCORING = {
    bestOf: 1,
    win: 1,
    draw: 0.5,
    loss: 0,
    bye: 1,
    tiebreaks: ["median buchholz", "solkoff", "cumulative"],
};
export const AI_NAMES = {
    CHESSIE: "Chessie",
    PROFESSOR_NINJA: "Professor Ninja",
    ALIEN_BRAIN: "Alien Brain",
};
export const CHESS_ENGINES = ["Stockfish", "Lozza", "P4wn"];
export const CHESS_ENGINE = {
    STOCKFISH: "Stockfish",
    LOZZA: "Lozza",
    P4WN: "P4wn",
};
export const TERMS = Object.freeze([
    { value: 1, label: "Term 1", startDate: "01-01" }, // 1st January
    { value: 2, label: "Term 2", startDate: "04-04" }, // 4th April
    { value: 3, label: "Term 3", startDate: "05-07" }, // 5th July
    { value: 4, label: "Term 4", startDate: "27-09" }, // 27th September
    { value: 5, label: "Other", startDate: null }, // No start date
]);
